import React, { useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import { loginWithCredentials, loginWithGoogle } from "./authService";
import { useAuth } from "./useAuth";
import { useApi } from "../../services/useApi";
import { getRuntimeConfig } from "../../config/runtimeConfig";

const LoginPage = () => {
  const { googleClientId } = getRuntimeConfig();
  const navigate = useNavigate();
  const api = useApi();
  const { setToken, setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const data = await loginWithCredentials(email, password);
      api.setToken(data.accessToken);
      setToken(data.accessToken);
      setUser(data.userInfo);
      navigate("/individual");
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    }
  };

  const handleGoogleLogin = async (credential) => {
    setError("");
    try {
      const data = await loginWithGoogle(credential);
      api.setToken(data.accessToken);
      setToken(data.accessToken);
      setUser(data.userInfo);
      navigate("/individual");
    } catch (err) {
      setError("Google login failed.");
    }
  };

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="auth-page">
        <div className="auth-card">
          <img
            className="auth-logo"
            src="/icons/Logo_PNG.png"
            alt="CatchClicker"
            style={{ width: "auto", height: 40, objectFit: "contain" }}
          />
          <h3 style={{ textAlign: "center", width: "100%", margin: "8px 0 0" }}>
            CatchClicker WEB
          </h3>
          <div className="auth-google">
            <GoogleLogin
              onSuccess={(credentialResponse) =>
                handleGoogleLogin(credentialResponse.credential)
              }
              onError={() => setError("Google login failed.")}
            />
          </div>
          <div className="auth-divider">or</div>
          <form onSubmit={handleLogin} className="auth-form">
            <input
              className="input"
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              className="input"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button variant="ghost" type="submit">
              Sign in
            </Button>
          </form>
          {error && <div className="auth-error">{error}</div>}
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginPage;
